import { isArray } from 'util';
export const isDay = [() => {
    return function (input, day) {
        var out = [];
        if(input && isArray(input)){
            input.forEach(d => {
                // console.log(d)
                if (new Date(d.start).getDate() == day.getDate() && 
                    new Date(d.start).getMonth() == day.getMonth() &&
                    new Date(d.start).getFullYear() == day.getFullYear()) {
                    out.push(d);
                }
            });
        }
        return out;
    };
}];


// WEBPACK FOOTER //
// ./src/app/filters/isDay.filter.ts